import { apolloClient } from "@/plugins/vue-apollo.js";

const changeCustomerStatus = (_variables) => {
  // , limit, skip
  let responseFromApi;
  let variables = _variables;

  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/user/api/mutations/change_customer_status.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/user/api/queries/customer/search_customer_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          }
        };
        let allUsers = store.readQuery(query);
        store.writeQuery({
          ...query,
            data: allUsers,
            status: data
        });
      }
    })
    .catch(error => {
      return error;
    });
  return responseFromApi;
};
export { changeCustomerStatus };
